import { Button, Checkbox, HorizontalSpacer, Label, Layout, LayoutHeader, Panel, RadioBox, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTabsetLiveDemoStyleAlignment extends Layout {
    buttonChevron: Button;
    buttonCreateTabset: Button;
    checkboxDivider: Checkbox;
    horizontalspacer1: HorizontalSpacer;
    labelHeaderTitle: Label;
    labelOptions: Label;
    layoutheaderTabsetStyles: LayoutHeader;
    panelHeader: Panel;
    panelOptions: Panel;
    radioboxAlignment: RadioBox;
    radioboxCaptionsImages: RadioBox;
    radioboxStyle: RadioBox;
    textboxHeadingMaxWidth: Textbox;
    textboxHeadingMinWidth: Textbox;
}
